const GE_LOGISTICA_GROUP = 'GeLogistica'
const DES_PROVEEDORES_GROUP = 'DesProveedores'
const COOR_PROV_GROUP = 'CoorProveeduria'
const COOR_ACO_GROUP = 'CoorCostos'
const AUX_CLARA_GROUP = 'AuxClara'
const AUX_CXP_GROUP = 'AuxCxP'
const AUX_COMPRAS_GROUP = 'AuxCompras'

const ACO_GROUP = 'ACo'
const JR_ACO_GROUP = 'ACoJr'
const SR_ACO_GROUP = 'ACoSr'
const SUPERVISOR_GROUP = 'Supervisor'
const AUX_CM_GROUP = 'AuxCM'
const ACO_CM_QUA_GROUP = 'ACoCMQUA'
const CODI_GROUP = 'CoDi'
const GEOP_GROUP = 'GeOp'
const PROVIDER_GROUP = 'Proveedor'
const ESAT_GROUP = 'EsAt'

const CXP_GROUP = 'CxP'
const FACTURACION_GROUP = 'Facturacion'
const COBRANZA_GROUP = 'Cobranza'

const EXTRANET_GROUPS = [
  'extranet_CoDi',
  'extranet_GeOp',
  'extranet_Supervisor',
  'extranet_Cliente'
]

const SUPPLIERS_GROUPS = [
  AUX_CLARA_GROUP,
  AUX_CXP_GROUP,
  AUX_COMPRAS_GROUP,
  COOR_PROV_GROUP,
  DES_PROVEEDORES_GROUP,
  GE_LOGISTICA_GROUP
]

const SUPPLIER_GROUPS_LOW_TIER = [
  'AuxClara',
  'AuxCxP',
  'AuxCompras'
]

export { EXTRANET_GROUPS, SUPPLIERS_GROUPS, SUPPLIER_GROUPS_LOW_TIER, DES_PROVEEDORES_GROUP, GE_LOGISTICA_GROUP,
  COOR_ACO_GROUP, JR_ACO_GROUP, SR_ACO_GROUP, ACO_GROUP, SUPERVISOR_GROUP, ACO_CM_QUA_GROUP, PROVIDER_GROUP, CODI_GROUP, GEOP_GROUP, ESAT_GROUP, AUX_CM_GROUP, CXP_GROUP, FACTURACION_GROUP, COBRANZA_GROUP, COOR_PROV_GROUP }
